module.exports = "/_next/static/images/floki-562e7146fd6644ad00196f94fde35919.svg";